<div [style.display]="dataLoading ? 'block' : 'none'" class="text-center" style="margin-top: 50px;">
    <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
</div>
<div class="container" [hidden]="dataLoading">
    <div class="single-column-layout">
        <h1>Roles</h1>
        <table class="roles table table-striped table-hover table-condensed">
            <tr>
                <th>Role Description</th>
                @for (entityType of entityTypes; track entityType) {
                    <th class="text-center">
                        {{ entityType }}
                    </th>
                }
            </tr>
            @for (role of roles; track role; let i = $index) {
                <tr>
                    <td>{{ role.roleDesc || '' }}</td>
                    @for (entityType of entityTypes; track entityType) {
                        <td class="text-center">
                            <input type="checkbox" [disabled]="true" [(ngModel)]="role[entityType]">
                        </td>
                    }
                </tr>
            }
        </table>
    </div>
</div>
